var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.275,
    height: 21.5,
    viewBox: "0 0 19.275 21.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_48904",
    "data-name": "Group 48904",
    transform: "translate(-18305 1361)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_93306",
    "data-name": "Path 93306",
    d: "M5.843,17.664l-4.53.3.3-4.531L14.3.75l4.226,4.23Z",
    transform: "translate(18305 -1361)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_595",
    "data-name": "Line 595",
    x2: 4.215,
    y2: 4.215,
    transform: "translate(18306.615 -1347.551)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_596",
    "data-name": "Line 596",
    x1: 17.776,
    transform: "translate(18305.75 -1340.25)",
    fill: "none",
    stroke: "#0c66e4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.c81d7401e5157573537a3880ea053511.svg";
export { ForwardRef as ReactComponent };